import React, { useEffect, useRef, useState } from "react";
import { AgentListModalProps, WorkflowAgent } from "./aiAgents/types";
import style from "./common.module.scss"
import disableTick from "../../../assets/svg/ai-agents/Vector (2).svg"
import enableTick from "../../../assets/svg/ai-agents/Vector (3).svg"
import CloseBtn from "../../../assets/svg/ai-agents/closebtn.svg"
import aiAgentsEmptyIcon from '../../../assets/svg/ai-agents/agent-modal-empty.svg'
import { ReactComponent as GeminiLogo } from '../../../assets/svg/ai-agents/geminiIcon.svg'
import { ReactComponent as ClaudeLogo } from '../../../assets/svg/ai-agents/claude-ai-icon.svg'
import { ReactComponent as GptLogo } from '../../../assets/svg/ai-agents/gptIcon.svg'
import { Input, Icon } from "antd";
import { Http } from "../../../helpers/axois";
import { AnimatePresence, motion } from "framer-motion";
import { modalVariants } from "./aiAgents/framerAnimations";
import moduleStyle from "../common/aiAgents/style.module.scss";
import { createColorPicker } from "./aiAgents/helpers";

export const AgentListModal = ({ setVisible, setSelectedAgent, selectedAgent, appId, branchId, versionId, appType, serviceId, updateAgentDetails, updateTask }: AgentListModalProps) => {
    const [flowAgentsDetails, setFlowAgentDetails] = useState<WorkflowAgent[]>([])
    const [searchValue, setSearchValue] = useState<string>("");
    const [selectedAgentDetails, setSelectedAgentDetails] = useState<{ key: string, id: string, inputVariable: string[], outputVariable: any[], isExternalAgent?: boolean }>({
        key: selectedAgent.key,
        id: selectedAgent.id,
        inputVariable: [],
        outputVariable: [],
        isExternalAgent: false
    })
    const [loading, setLoading] = useState<boolean>(false);
    const modalRef = useRef(null);

    const getAgentsLists = () => {
        setLoading(true)
        Http.get(`/apps/${appId}/ai-agents?branchId=${branchId}&versionId=${versionId}`).subscribe((res: any) => {
            if (res.aiAgents) {
                const agents =  res?.aiAgents || []
                const index = agents.findIndex((agent:WorkflowAgent) => agent.isExternal ? (selectedAgentDetails.key === `uniphore:${agent.name}` || selectedAgentDetails.key === agent.name) : selectedAgentDetails.key === agent.aiAgentKey)
                if (index !== -1) {
                    const [agent] = agents.splice(index, 1);
                    agents.unshift(agent);
										if(agent.isExternal) {
											setSelectedAgentDetails(prev => ({ ...prev, isExternalAgent: true }))
										}
                }
                setFlowAgentDetails(agents)
                setLoading(false)
            }
        }, (err) => {
            setLoading(false)
            console.log({ err })
        })
    }

    useEffect(() => {
        getAgentsLists()
    }, [])

    const filteredAgentList = flowAgentsDetails?.filter((prompt) =>
        prompt.name.toLowerCase().includes(searchValue.toLowerCase())    
    );

    const agentsLists = searchValue ? filteredAgentList : flowAgentsDetails;
    return (
        <>
            <AnimatePresence>
                <div className={style.modalOverlay}>
                    <motion.div 
                        className={style.modalContent} 
                        ref={modalRef}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        variants={modalVariants}
                    >
                        <div className={style.modalHeader}>
                            <p className={style.modalHeaderTitle}>AI Agents</p>
                            <img alt="close-btn" style={{ cursor: "pointer", width: "15px", height: "15px", marginRight: "9px" }} src={CloseBtn} onClick={() => { setVisible(false) }} />
                        </div>

                        {<div style={{ padding: 15 }}>
                            <Input value={searchValue}
                                className="prompt-gallery-search"
                                prefix={<Icon type="search" />}
                                onChange={(e) => { setSearchValue(e.target.value) }}
                                placeholder="Search agent"
                            />
                        </div>}
                        {<div className={style.agentListContainer} style={{ overflow: "auto", height: 420, cursor: "pointer", display: agentsLists?.length === 0 ? "flex" : "grid" }}>
                            {(() => {
                                const cardColor = createColorPicker();
                                return (agentsLists?.length > 0 && !loading) && agentsLists.map((agent, index) => {
                                    return (
																			<div key={agent.id} onClick={() => {
                                                setSelectedAgentDetails({ key: agent.isExternal ? `uniphore:${agent.name}` : agent.aiAgentKey, id: selectedAgent.id, inputVariable: agent.inputVars, outputVariable: agent.outputParams, isExternalAgent: agent.isExternal })
                                            }} className={style.agentCard} style={{
                                                background: cardColor(index).background,
                                                border: ((selectedAgentDetails.key !== `uniphore:${agent.name}`) && (selectedAgentDetails.key !== agent.aiAgentKey && selectedAgentDetails.key !== agent.name)) ? `1px solid ${cardColor(index).border}` : "1px solid #51808c",

                                            }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <h2 className={style.agentName}>{agent.name}</h2>
                                                    <img alt="tick-icons" src={((selectedAgentDetails.key !== agent.aiAgentKey && selectedAgentDetails.key !== agent.name) && (selectedAgentDetails.key !== `uniphore:${agent.name}`)) ? disableTick : enableTick} />
                                                </div>
                                                <p className={style.agentDesc}>{agent.prompt}</p>
                                                <div style={{ display: "flex", alignItems: "center", flexDirection: "row" }}>
                                                    {agent.llm.provider === "openai" ? <GptLogo /> : agent.llm.provider === "gemini" ? <GeminiLogo /> : <ClaudeLogo />}
                                                    <span style={{
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        paddingLeft: 5,
                                                        background: agent.llm.provider == "openai" ? "#000000" : agent.llm.provider === "gemini" ? "linear-gradient(91.41deg, #8B3CDA -11.53%, #3C92DA 98.8%)" : "#ba5b38",
                                                        WebkitTextFillColor: "transparent",
                                                        backgroundClip: "text",
                                                        WebkitBackgroundClip: "text",
                                                        display: "inline-block",
                                                        textTransform: "capitalize"
                                                    }}>
                                                        {agent.llm.provider}</span>
                                                    <div className={style.variableCardDivider}></div>
                                                    <span style={{ paddingLeft: 10, color: "#000000", fontSize: 12, fontWeight: 500 }}>{agent.llm.model}</span>
                                                </div>
                                            </div>
                                    )
                                })
                            })()}
                        
                            {(loading && !agentsLists?.length) ? <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '20px' }}><div className={moduleStyle.spinner}></div></div> : <></>}
                            {(agentsLists?.length === 0 && !loading) &&
                                <div className={style.aiAgentsEmptyContainer}>
                                    <img src={aiAgentsEmptyIcon} alt="empty-agents"/>
                                    <h1 style={{ color: "#000000", fontWeight: 700, fontSize: 16, margin: "30px 0px 20px 0px" }}>No Agents Created</h1>
                                    <div style={{ width: 330, textAlign: "center", color: "#292D32", fontSize: 14 }}>It seems no agents have been created yet.</div>
                                </div>}
                        </div>}
                        {(agentsLists?.length > 0 && !loading) &&
                            <>
                                <div className={style.divider}></div>
                                <div className={style.modalFooter}>
                                    <button className={style.modalFooterBtn} onClick={() => { setVisible(false) }}>Cancel</button>
                                <button className={style.modalFooterApplyBtn} style={{ background: "#51808C", border: "1px solid #51808C"}} onClick={() => {
                                        if (appType === "assisted" && updateAgentDetails && updateTask && serviceId) {
                                            updateAgentDetails({ key: selectedAgentDetails.key || "", id: selectedAgentDetails.id })
                                            updateTask(serviceId, selectedAgentDetails.key || "", true, {}, '', selectedAgentDetails.isExternalAgent)
                                        } else if (setSelectedAgent) {
                                            setSelectedAgent({ isExternalAgent: selectedAgentDetails.isExternalAgent, key: selectedAgentDetails.key || "", id: selectedAgentDetails.id, inputVariable: selectedAgentDetails.inputVariable, outputVariable: selectedAgentDetails.outputVariable, agentSelect: true })
                                        }
                                        setVisible(false)
                                    }}>Submit</button>
                                </div>
                            </>}
                    </motion.div>
                </div>
            </AnimatePresence>
        </>
    )
}